import * as React from 'react';
import useWindowSize from 'hooks/useWindowSize';


const Face = ({
    fill = '#878B87',
    stroke = '#11F9AF',
    width = '223',
    height = '296',
    ...attributes
}: React.SVGProps<SVGSVGElement>) => {
    const windowSize = useWindowSize()
    ///console.log(windowSize);

    return (windowSize.width > 950 ? <svg width={width} height={height} {...attributes} viewBox="0 0 285 399" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M141.702 397.498C102.222 396.739 67.2083 370.937 41.9854 333.404C16.7563 295.862 1.5 246.816 1.5 200.189V141.812C1.5 64.0443 64.4228 1.5 141.769 1.5C219.116 1.5 282.038 64.0457 282.038 141.812C282.038 141.825 282.039 141.838 282.039 141.85L283.5 199.886C283.496 246.507 268.421 295.624 243.107 333.238C217.779 370.873 182.366 396.778 141.743 397.497C141.729 397.497 141.716 397.498 141.702 397.498Z" stroke={stroke} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    </svg> : <svg width="225" height="315" {...attributes} viewBox="-1 0 290 400" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M140.493 392.497C140.462 392.497 140.43 392.498 140.399 392.5C100.924 392.46 66.2396 367.044 41.34 329.876C16.4338 292.697 1.5 243.998 1.5 198.04V140.5C1.5 63.857 63.8528 1.5 140.493 1.5C217.133 1.5 279.486 63.8584 279.486 140.5V198.037C279.486 243.991 264.553 292.691 239.647 329.87C214.728 367.069 180.008 392.497 140.493 392.497Z" stroke={stroke} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
</svg>)
};

export default Face;
